import React from 'react';
import '@web/styles/spinner.css';

type ISpinnerProps = {
  isLoading: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const Spinner = ({ isLoading, ...rest }: ISpinnerProps) => {
  if (!isLoading) return null;
  return (
    <div className="flex items-center gap-x-2" {...rest}>
      <svg
        className="spinner"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
    </div>
  );
};

export const BtnSpinner = ({ isLoading }: ISpinnerProps) => {
  return <Spinner isLoading={isLoading} className="mr-1" />;
};
